import { useEffect } from 'react';
import { publishSimulatorGate, useExperimentSimulatorEnabled } from '@/services/experiment-simulator';

/** Keeps `window.__cioExperimentSimulator` and the `gate` message in step with the simulator gate. */
export function usePublishSimulatorGate(): void {
  const isOpen = useExperimentSimulatorEnabled();
  // The window global and its message are the external system Ember reads.
  useEffect(() => {
    publishSimulatorGate(isOpen);
  }, [isOpen]);
}
